import { memo, ReactNode, useMemo } from "react";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { filterRealRoutes } from "../../utils";
import { BreadcrumbsContext } from "../ui";
import { useRoutesContext } from "./RoutesContext";


export type BreadcrumbsContextProviderProps = {
  children: ReactNode | ReactNode[]
}

export const BreadcrumbsContextProvider = memo<BreadcrumbsContextProviderProps>(({ children }) => {
  const routes = useRoutesContext();
  const realRoutes = useMemo(() => filterRealRoutes(routes), [ routes ]);
  const breadcrumbs = useBreadcrumbs(realRoutes, { disableDefaults: true });

  return (
    <BreadcrumbsContext.Provider value={breadcrumbs.map((x, index) => ({
      to: x.match.pathname,
      title: x.breadcrumb,
      disabled: index === (breadcrumbs.length - 1),
    }))}>
      {children}
    </BreadcrumbsContext.Provider>
  );
});

export default BreadcrumbsContextProvider;